<template>
  <div>
    <DepartmentRuleDetail type="edit" :submitting="submitting" :values="data" @submit="submit" />
  </div>
</template>

<script>
import { helper } from '@core/mixins/helper';
import useService from '@/auth/service/useService';
import DepartmentRuleDetail from '@/views/pages/departments/rule/DepartmentRuleDetail.vue';

export default {
  components: {
    DepartmentRuleDetail
  },
  mixins: [helper],

  data() {
    return {
      submitting: false,
      id: '',
      data: {}
    };
  },

  created() {
    const departmentId = this.$route.params.id;
    this.id = departmentId;
    this.getDepartmentRuleDetail(departmentId);
  },

  methods: {
    submit(data) {
      const { ruleId } = this.$route.params;
      this.submitting = true;
      useService.departmentService
        .editDepartmentRule(this.id, ruleId, {
          ...data
        })
        .then(response => {
          if (response.status) {
            this.showSuccessMessage(`${response.message}`);
            this.$router.push(`/departments/${this.id}/rules`);
          }
        })
        .catch(messages => {
          if (typeof messages === 'object' && messages && messages.length) {
            messages.forEach(item => {
              this.showErrorMessage(item.message);
            });
          }
        })
        .finally(() => {
          this.submitting = false;
        });
    },

    getDepartmentRuleDetail(ruleId) {
      ruleId = this.$route.params.ruleId;
      this.submitting = true;
      useService.departmentService
        .getDepartmentRule(ruleId)
        .then(response => {
          this.data = response.data;
        })
        .catch(messages => {
          if (typeof messages === 'object' && messages && messages.length) {
            messages.forEach(item => {
              this.showErrorMessage(item.message);
            });
          }
        })
        .finally(() => {
          this.submitting = false;
        });
    }
  }
};
</script>
